import { render, staticRenderFns } from "./purchase-edit.vue?vue&type=template&id=724182e9&scoped=true"
import script from "./purchase-edit.vue?vue&type=script&lang=js"
export * from "./purchase-edit.vue?vue&type=script&lang=js"
import style0 from "./purchase-edit.vue?vue&type=style&index=0&id=724182e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724182e9",
  null
  
)

export default component.exports